import { atom } from 'recoil'

export const previewVideoState = atom<number | undefined>({
  key: 'preview_video',
  default: undefined,
})
